<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <line x1="2" y1="5" x2="22" y2="5" [attr.stroke]="stroke" stroke-width="2" />
  <line x1="2" y1="12" x2="22" y2="12" [attr.stroke]="stroke" stroke-width="2" />
  <line x1="2" y1="19" x2="22" y2="19" [attr.stroke]="stroke" stroke-width="2" />
</svg>
